import { type useTranslations } from 'next-intl';

type TFunction = ReturnType<typeof useTranslations>;
export type { TFunction };

/* This function takes a string which could include apostrophes and underscores and replaces them with a space and converts the string to be lowercase */
export function convertStringToTranslationKey(str: string) {
  const word = (str ?? '')
    .trim()
    .replace(/[''`´]/g, '')
    .toLowerCase();

  return word
    .replace(/[_\s\/]+/g, ' ') // normalize all separators (including forward slashes) to a single space
    .replace(/\b[a-z0-9]/g, (c) => c.toUpperCase()) // capitalize each word start
    .replace(/ /g, ''); // remove spaces → PascalCase
}

/*
This helper checks for an existing translation key with a prefix. If that exists, it returns the localied value,
otherwise it returns the original key without the prefix.

e.g: ActiveFilters.Trainers where "ActiveFilters" is the prefix.
*/

export function getTranslationFromPrefix(
  key: string,
  translationFn: TFunction,
  prefix: string
) {
  const translationKey = prefix
    ? `${prefix}.${convertStringToTranslationKey(key)}`
    : convertStringToTranslationKey(key);

  const value = translationFn.has(translationKey)
    ? translationFn(translationKey)
    : key;

  /*
    this check is for when there is no value for the translation key in our messages json.
    In this instance next-intl will return the default key e.g ActiveFilter.Trainers so we return the key without the prefix.
  */

  if (value?.startsWith(`${prefix}`)) {
    return key;
  }

  return value;
}
